import Statistical from './statistical.jsx';

export { Statistical };



// WEBPACK FOOTER //
// ./src/components/modules/thong-ke/index.js